import { z } from 'zod';
import { idSchema, isoDateSchema } from '../primitives/branded.js';
import { positivePriceSchema } from '../primitives/numeric.js';
import { timestampSchema } from '../primitives/timestamp.js';
/**
 * Verlauf der Stop-Loss-Entscheidungen.
 *
 * Die Anwendung soll zeigen, **wie** ein Stop über die Zeit nachjustiert wurde —
 * nicht nur, wo er gerade steht. Jede Änderung überschreibt sonst die vorige, und
 * damit ginge genau die Information verloren, aus der sich eine Arbeitsweise
 * ablesen lässt: Habe ich den Stop nachgezogen, als der Kurs lief? Wie oft? Wie
 * lange lag eine Order beim Broker, bevor ich sie erneuert habe?
 *
 * Festgehalten wird jede Entscheidung, nicht jeder Zustand. Deshalb ein Ereignis
 * je Handlung statt einer periodischen Momentaufnahme.
 */
export const stopLossEventTypeSchema = z.enum(['adjusted', 'booked', 'unbooked']);
export const STOP_LOSS_EVENT_LABELS = {
    adjusted: 'Stop-Loss gesetzt',
    booked: 'Beim Broker eingebucht',
    unbooked: 'Einbuchung aufgehoben',
};
export const stopLossEventSchema = z.object({
    id: idSchema,
    positionId: idSchema,
    type: stopLossEventTypeSchema,
    /** Der Kurs, um den es bei diesem Ereignis ging. */
    stopPrice: positivePriceSchema.nullable(),
    /**
     * Der zuvor geltende Kurs.
     *
     * Erlaubt, die Bewegung ohne Blick auf den Vorgängereintrag zu lesen — und
     * bleibt richtig, auch wenn ältere Einträge später einmal verdichtet werden.
     */
    previousStopPrice: positivePriceSchema.nullable(),
    /** Bei einer Einbuchung: bis wann die Order gilt. */
    validUntil: isoDateSchema.nullable(),
    /**
     * Schlusskurs im Moment der Entscheidung.
     *
     * Ohne ihn ließe sich später nicht mehr sagen, ob ein Stop eng oder weit gesetzt
     * war — der Kurs von damals ist nicht mehr rekonstruierbar, ohne die Historie
     * erneut zu durchsuchen.
     */
    referenceClose: positivePriceSchema.nullable(),
    createdAt: timestampSchema,
});
/** Eintrag, wie ihn der Server schreibt. */
export const createStopLossEventSchema = stopLossEventSchema.omit({ id: true, createdAt: true });
//# sourceMappingURL=stop-loss-history.js.map